module.exports = __webpack_public_path__ + "static/media/iconService.d0014c65.png";